import React from 'react'

import { render } from '~utils/rehype-render'
import { 
  Observer
} from '~components/Markdown'

import style from './Content.module.scss'

const Content = ({
  ast
}) => (
  <div className={ style.content }>
    <Observer>
      { render(ast) }
    </Observer>
  </div>
)

export default Content